import styled from 'styled-components';
import { lightGrey1Color } from 'js/config/style';
import { upTo } from 'js/services/MediaQuery';
import { breakpoint } from './Grid';

export default styled.div`
  grid-area: panel;
  box-shadow: -5px 0px 10px -10px black;
  background: white;
  border: 1px solid ${lightGrey1Color.darken(0.5)};
  border-radius: 0.25rem;
  position: relative;
  z-index: 2;

  & > div {
    display: grid;
    min-height: 100%;
  }

  ${upTo(breakpoint)`
    box-shadow: none;
  `}
`;
